// COMPONENTS
import { Outlet } from "react-router-dom";
import { SelectedOpenPartOrdersProvider } from "../../contexts/parts/selectedOpenPartOrders.part.context";
import { SelectedOrderedPartsProvider } from "../../contexts/parts/selectedOrderedParts.part.context";
import { VendorsProvider } from "../../contexts/vendors.context";

const PartsLayout = () => {
  return (
    <VendorsProvider>
      <SelectedOpenPartOrdersProvider>
        <SelectedOrderedPartsProvider>
          <Outlet />
        </SelectedOrderedPartsProvider>
      </SelectedOpenPartOrdersProvider>
    </VendorsProvider>
  );
};

export default PartsLayout;
